import { useFileDownload } from '../../File'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import { FileListItem } from '../FileListItem'
import { FilesGalleryActions } from '../FilesGalleryActions'

import * as styles from './FilesGallery.module.css'

function FilesGallery({ activeFile, files, scope, ...actionsProps }) {
  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({ files })

  const { downloadFile } = useFileDownload({
    apiParams: {
      scope,
    },
    file: activeFile,
  })

  return (
    <div className={styles.FilesPreviewGallery}>
      <FileListItem
        gallery
        file={activeFile}
        onClick={handleClickFile}
        onDownloadClick={downloadFile}
      />
      <FilesGalleryActions {...actionsProps} totalCount={files.length} />
      <FilesPreviewGallery
        files={files}
        initActive={activeFileIndex}
        scope={scope}
        onClose={handleCloseFilePreview}
      />
    </div>
  )
}

export default FilesGallery
